const sections = {
  orderlist: 'Order List',
  ordersExport: 'Orders Export',
  orders: 'Orders',
  marketplaceorders: 'Market Place Orders',
  invoicesExport: 'Invoices export',
  subscriptions: 'Subscriptions',
  invoices: 'Invoices',
  licenses: 'Licenses',
  carts: 'Carts',
  archivedorders: 'Archived Orders',
  stores: 'Stores',
  checkoutpagebuilder: 'Checkout Page Builder',
  storesetup: 'Store Setup',
  themes: 'Themes',
  layouts: 'Layouts',
  fonts: 'Fonts',
  markups: 'Markups',
  localization: 'Localization',
  translations: 'Translations',
  invoicetranslations: 'Invoice Translations',
  emailbuilder: 'Email Builder',
  productlist: 'Product List',
  products: 'Products',
  pricemodels: 'Price Models',
  priceImportExport: 'Price Import/Export',
  prices: 'Prices',
  pricefunctions: 'Price Functions',
  importExportPrices: 'Prices Import & Export',
  recommendations: 'Recommendations',
  fulfillment: 'Fulfillment Packages',
  autoFulfillments: 'Auto Fulfillments',
  manualFulfillments: 'Manual Fulfillments',
  licenseProviderDefinitions: 'License Provider Definitions',
  catalogs: 'Catalogs',
  marketing: 'Marketing',
  discountrules: 'Discount Rules',
  campaigns: 'Campaigns',
  marketingCampaigns: 'Marketing Campaigns',
  marketingAbandoned: 'Marketing Abandoned',
  licenseExpiration: 'License Expiration',
  endusers: 'End-Users',
  enduserlist: 'End-User List',
  endusergroups: 'End-User Groups',
  resellers: 'Resellers',
  reports: 'Reports',
  settings: 'Settings',
  users: 'Users',
  userroles: 'User Roles & Profiles',
  roles: 'Roles',
  metaRoles: 'Meta Roles',
  profiles: 'Profiles',
  privileges: 'Privileges',
  notifications: 'Notifications',
  'notification-receivers': 'Notification Receivers',
  'notification-definition': 'Notification Definition',
  'notification-history': 'Notification History',
  myaccount: 'My Account',
  customermanagement: 'Customer Management',
  customerslist: 'Customers List',
  onboarding: 'Onboarding',
  remittables: 'Remittables',
  audits: 'Audits',
  sales: 'Sales',
  businessAnalysis: 'Business Analysis',
  realms: 'Realms List',
  referentials: 'Referentials',
  currencies: 'Currencies',
  locales: 'Locales',
  countries: 'Countries',
  referentialmanager: 'Referential Manager',
  serviceconfiguration: 'Service Configuration',
  subsidiarymanager: 'Subsidiary Manager',
  subsidiaries: 'Subsidiaries',
  subsidiaryrules: 'Subsidiary Rules',
  crudHelper: 'C.R.U.D. Helper resource list',
  crudHelperRequest: 'C.R.U.D. Console',
  customFieldsDefinition: 'Custom fields',
  tncmanager: 'T&C Manager',
  tncrunning: 'Running',
  tncdraft: 'Draft',
  tncarchived: 'Archived',
  exportManagement: 'Export Management',
  exportManagementSubscriptions: 'Export Management Subscriptions',
  exportManagementProducts: 'Export Management Products',
  exportManagementDiscountRules: 'Export Management Discount Rules',
  monitoring: 'Monitoring',
  subscriptionMonitoring: 'Subscription Monitoring',
  orderCancellations: 'Order Cancellations',
  ordersExportList: 'Export list',
  ordersExportSearch: 'Search',
};

export default sections;
